import { createFileRoute } from "@tanstack/react-router";
import { DiscordSettingsPage } from "@/shared/pages/discord/settings-page";

export const Route = createFileRoute("/_protected/discord/settings")({
  component: DiscordSettingsPage,
});
